export const be = {
    LEFT: 'Налева: пераход да папярэдняга дня.',
    RIGHT: 'Направа: пераход да наступнага дня.',
    DOWN: 'Ўніз: перайсці да наступнай радку.',
    UP: 'Ўверх: перайсці да папярэдняй радку.',
    PGUP: 'Уверх: перамяшчэнне да папярэдняга месяца.',
    PGDOWN: 'PgDown: перайсці на наступны месяц.',
    HOME: 'Дома: пераход да папярэдняга годзе.',
    END: 'Канец: перанесці на наступны год.',
    ESC: 'Эку/сёння/закрыць: зачыніць каляндар. Інструкцыі',
    TITLE: 'Клавіятура '
};
